import React from 'react';
import { Link } from 'react-router-dom';
import { therapyList } from '../constants/therapies';
import { getUserSession, isValidSession } from '../services/authService';
import '../styles/services.css';

const ServiceTherapiesPage = () => {
  const sessionUser = getUserSession();
  const isLoggedIn = isValidSession(sessionUser);

  return (
    <div className="services-root">
      <section className="services-section services-section-intro">
        <div className="services-hero-card">
          <h1 className="services-hero-title">Nuestras Terapias</h1>
          <p className="services-hero-text">
            Conoce las terapias que ofrecemos en Beyond Limits Foundation. Cada una está diseñada
            para acompañar el desarrollo integral, potenciar habilidades y brindar un apoyo cercano a
            cada persona y su familia.
          </p>
        </div>
      </section>

      {!isLoggedIn ? (
        <section className="services-section">
          <div className="therapies-notice">
            <p className="therapies-notice-text">
              Para tomar una terapia debes registrarte en la página.
            </p>
            <Link to="/registro" className="therapies-notice-button">
              Registrarme
            </Link>
          </div>
        </section>
      ) : null}

      <section className="services-section services-section-catalog">
        <div className="therapies-grid">
          {therapyList.map((therapy) => (
            <article key={therapy.id} className="therapies-card">
              <h2 className="therapies-card-title">{therapy.title}</h2>
              <p className="therapies-card-description">{therapy.description}</p>
            </article>
          ))}
        </div>
      </section>
    </div>
  );
};

export default ServiceTherapiesPage;
